module.exports = __webpack_public_path__ + "img/konfigurasi_pesan.e2a273ed.svg";